var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit, invalid }) {
          return [
            _c(
              "form",
              {
                staticClass: "form-horizontal",
                attrs: { role: "form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c(
                  "fieldset",
                  [
                    _vm.currentBuyer.id
                      ? _c("Field", {
                          attrs: {
                            label: _vm.$t("BUYER_ID"),
                            "has-tooltip": false
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "element",
                                fn: function() {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-sm-6 col-md-4 p-t-2 p-b-10"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "clipboard",
                                                rawName: "v-clipboard",
                                                value: {
                                                  copyText: _vm.currentBuyer.id
                                                },
                                                expression:
                                                  "{ copyText: currentBuyer.id }"
                                              },
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: "Copy",
                                                expression: "'Copy'"
                                              }
                                            ],
                                            staticClass:
                                              "btn btn-link m-l-5 p-0 no_border",
                                            attrs: { placement: "right" }
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "typcn typcn-tabs-outline"
                                            })
                                          ]
                                        ),
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(_vm.currentBuyer.id) +
                                            "\n          "
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("BUYER_COMPANY"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("BUYER_COMPANY_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "name",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-6 col-sm-4 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentBuyer.name,
                                                        expression:
                                                          "currentBuyer.name"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "BUYER_COMPANY_DEFAULT"
                                                      ),
                                                      type: "text",
                                                      name: "name",
                                                      "data-testid":
                                                        "buyer-form-name",
                                                      autocomplete: "off",
                                                      "custom-autofocus": "true"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.currentBuyer.name
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.currentBuyer,
                                                          "name",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("BUYER_SUBID"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("BUYER_SUBID_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "subId",
                                  attrs: { slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-6 col-sm-4 col-md-4"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.currentBuyer
                                                            .subId,
                                                        expression:
                                                          "currentBuyer.subId"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "BUYER_SUBID_DEFAULT"
                                                      ),
                                                      name: "subId",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.currentBuyer.subId
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.currentBuyer,
                                                          "subId",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("BUYER_ALLOW_PAUSE_TARGET"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("BUYER_ALLOW_PAUSE_TARGET_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "canPauseTargets",
                                  attrs: { rules: "", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 col-sm-8"
                                                },
                                                [
                                                  _c("NzToggle", {
                                                    attrs: {
                                                      name: "canPauseTargets"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentBuyer
                                                          .canPauseTargets,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentBuyer,
                                                          "canPauseTargets",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentBuyer.canPauseTargets"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("BUYER_ALLOW_SET_TARGET_CONCURRENCY"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "BUYER_ALLOW_SET_TARGET_CONCURRENCY_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "canSetConcurrencyCaps",
                                  attrs: { rules: "", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 col-sm-8"
                                                },
                                                [
                                                  _c("NzToggle", {
                                                    attrs: {
                                                      name:
                                                        "canSetConcurrencyCaps"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentBuyer
                                                          .canSetConcurrencyCaps,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentBuyer,
                                                          "canSetConcurrencyCaps",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentBuyer.canSetConcurrencyCaps"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("BUYER_ALLOW_DISPUTE_CONVERSION"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "BUYER_ALLOW_DISPUTE_CONVERSION_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "canDisputeConversions",
                                  attrs: { rules: "", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-md-8 col-sm-8"
                                                },
                                                [
                                                  _c("NzToggle", {
                                                    attrs: {
                                                      name:
                                                        "canDisputeConversions"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.currentBuyer
                                                          .canDisputeConversions,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.currentBuyer,
                                                          "canDisputeConversions",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "currentBuyer.canDisputeConversions"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("CapSetting", {
                      attrs: {
                        "cap-settings-type": _vm.capSettingType,
                        "call-caps": _vm.callCaps,
                        "settings-object-container": _vm.currentBuyer.capacity,
                        "translation-dictionary": _vm.buyerCapFieldsTranslation,
                        "enable-caps-label": _vm.$t("BUYER_HAS_CAPS"),
                        "enable-caps-tooltip": _vm.$t("BUYER_HAS_CAPS_TT"),
                        readonly: false
                      },
                      on: {
                        "change-call-caps": _vm.changeCallCaps,
                        "change-settings-object-container":
                          _vm.changeSettingsObjectContainer,
                        "remove-caps": function($event) {
                          return _vm.removeCaps()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.hasRevenueRecovery
                      ? _c("RevenueRecovery", {
                          attrs: {
                            "toggle-options":
                              _vm.revenueRecoverySettingsOptions,
                            setting: _vm.currentBuyer.hangupRerouteSetting,
                            "tooltip-text": _vm.$t(
                              "DIAL_SETTINGS_REVENUE_RECOVERY_BUYER_TT"
                            )
                          },
                          on: { change: _vm.updateRevenueRecoverySetting }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BuyerRouteDuplicateSetting", {
                      attrs: { setting: _vm.currentBuyer.routeDuplicates },
                      on: {
                        change: function($event) {
                          return _vm.onDuplicateSettingChange($event)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.hasRpc
                      ? _c(
                          "div",
                          [
                            _c(
                              "legend",
                              { staticClass: "col-lg-offset-1 col-lg-10" },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("RPC_SETTING_TITLE")))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.hover.right",
                                        value: _vm.$t("RPC_SETTING_TITLE_TT"),
                                        expression:
                                          "$t('RPC_SETTING_TITLE_TT')",
                                        modifiers: { hover: true, right: true }
                                      }
                                    ],
                                    staticClass: "m-l-10 f-s-16"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-question-circle"
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("Field", {
                              staticClass: "m-b-5",
                              attrs: {
                                label: _vm.$t("ERPC"),
                                "has-tooltip": true,
                                "tooltip-text": _vm.$t("USE_ERPC_TT")
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "element",
                                    fn: function() {
                                      return [
                                        _c("ValidationProvider", {
                                          ref: "rpcSetting",
                                          attrs: { rules: "", slim: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function({ classes }) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      { class: classes },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "ol-sm-9 col-md-9"
                                                          },
                                                          [
                                                            _c(
                                                              "MultipleToggle",
                                                              {
                                                                attrs: {
                                                                  options:
                                                                    _vm.rpcSettingsOptions,
                                                                  value:
                                                                    _vm.overrideRpcSetting
                                                                },
                                                                on: {
                                                                  onToggle:
                                                                    _vm.onRPCSettingToggled
                                                                }
                                                              }
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _c("RPCSettings", {
                              attrs: {
                                "rpc-setting": _vm.currentBuyer.rpcSetting,
                                rpc: _vm.rpcItem,
                                "priority-bump": _vm.currentBuyer.priorityBump,
                                "entity-type": "buyer",
                                "show-setting-section-header": false
                              },
                              on: {
                                "rpc-settings-change": _vm.onRPCSettingsChange,
                                "rpc-change": _vm.onRPCChange,
                                priorityBumpChange: _vm.onPriorityBumpChange
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("ShareableTags", {
                      attrs: {
                        "override-shareable-tags": _vm.overrideShareableTags,
                        "shareable-tag-setting":
                          _vm.currentBuyer.shareableTagSetting,
                        "available-tags": _vm.tags,
                        "loading-tags": _vm.isLoadingTags
                      },
                      on: {
                        "update:overrideShareableTags": function($event) {
                          _vm.overrideShareableTags = $event
                        },
                        "update:override-shareable-tags": function($event) {
                          _vm.overrideShareableTags = $event
                        },
                        "update:shareableTagSetting": function($event) {
                          return _vm.$set(
                            _vm.currentBuyer,
                            "shareableTagSetting",
                            $event
                          )
                        },
                        "update:shareable-tag-setting": function($event) {
                          return _vm.$set(
                            _vm.currentBuyer,
                            "shareableTagSetting",
                            $event
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        attrs: { "data-testid": "submit-wrapper" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                          },
                          [
                            invalid && _vm.triedToSend
                              ? _c(
                                  "p",
                                  { staticClass: "m-t-8 m-b-8 bright-red" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "f-s-20 p-r-0 typcn typcn-warning"
                                    }),
                                    _vm._v(
                                      _vm._s(_vm.$t("INVALID_FORM")) +
                                        "\n          "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "PrimaryButton",
                              {
                                attrs: {
                                  size: "sm",
                                  "show-loader-on-form": _vm.showLoader,
                                  "data-testid": "submit"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.triedToSend = true
                                  }
                                }
                              },
                              [
                                _c("span", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: _vm.currentBuyer.id
                                        ? "UPDATE"
                                        : "CREATE",
                                      expression:
                                        "currentBuyer.id ? 'UPDATE' : 'CREATE'"
                                    }
                                  ]
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c("button", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: "CANCEL",
                                  expression: "'CANCEL'"
                                }
                              ],
                              staticClass: "btn btn-sm btn-danger m-l-15",
                              attrs: { "data-testid": "cancel" },
                              on: { click: _vm.cancel }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }